import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useAdminAuth } from "./AdminAuthContext";
import adminApi from "./adminApi";

export default function AdminProtectedRoute({ children }) {
  const { user, loading, signOut } = useAdminAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!user) {
      setChecking(false);
      setAuthorized(false);
      return;
    }
    let cancelled = false;
    setChecking(true);
    adminApi
      .get("/api/admin/whoami")
      .then(() => {
        if (!cancelled) setAuthorized(true);
      })
      .catch(() => {
        if (!cancelled) {
          setAuthorized(false);
          signOut();
        }
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user, loading, signOut]);

  if (loading || checking) {
    return (
      <div style={{ textAlign: "center", marginTop: "4rem" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user || !authorized) {
    return (
      <Navigate
        to="/admin/login"
        state={{ from: location, unauthorized: !!user && !authorized }}
        replace
      />
    );
  }

  return children;
}
